import { render } from "./Deactivate.vue?vue&type=template&id=06a4a536"
import script from "./Deactivate.vue?vue&type=script&lang=js"
export * from "./Deactivate.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__